'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const ControllerExtensions=require('../../../../dist-es6/client/extensions/controllerExtensions');
const BaseController=require('../../../../dist-es6/client/angularCommon/baseController');let

NotificationSettingsController=function(_BaseController){_inherits(NotificationSettingsController,_BaseController);_createClass(NotificationSettingsController,null,[{key:'$inject',get:function()
{
return['$timeout','uncaughtErrorHandler','userService','breadcrumbsService','groupBasedDataHelperService'];
}}]);

function NotificationSettingsController($timeout,uncaughtErrorHandler,userService,breadcrumbsService,groupBasedDataHelperService){_classCallCheck(this,NotificationSettingsController);var _this=_possibleConstructorReturn(this,
_BaseController.call(this,uncaughtErrorHandler));

_this._$timeout=$timeout;
_this._userService=userService;

_this.notificationSettingsSubViewConfiguration=_this._getNotificationSettingsSubViewConfiguration();

breadcrumbsService.startTrail('Email Notifications');


groupBasedDataHelperService.clearCaches();return _this;
}NotificationSettingsController.prototype.





_getNotificationSettingsSubViewConfiguration=function _getNotificationSettingsSubViewConfiguration(){
return ControllerExtensions(this).getMultiViewConfigurationFor(['emailAddress'],[{
label:'Notification Settings',
directiveName:'pulsar-groups-notification-settings-subview'},
{
label:'Do Not Disturb',
directiveName:'pulsar-do-not-disturb-notification-settings'}]);

};_createClass(NotificationSettingsController,[{key:'emailAddress',get:function(){return _.get(this._userService,'currentUser.email')}}]);return NotificationSettingsController}(BaseController);


module.exports=NotificationSettingsController;
//# sourceMappingURL=notificationSettingsController.js.map
